export default __webpack_public_path__ + "static/media/img_tutorial_three.c316523c.png";